/**
 * @generated SignedSource<<83473b882cebebf3a3d271e8a8d1c7fb>>
 * @relayHash e8bdd087745c04953d57f1c1345e6a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a22d0ca655cf4288f757f976fb178eb41f2f12035fd04dc15fd5ee0d49d43033

import type { ConcreteRequest, Query } from 'relay-runtime';
export type mainSideNavKBTypeCheckerQuery$variables = {
  cloudId: string;
  container: string;
  isEnabled: boolean;
};
export type mainSideNavKBTypeCheckerQuery$data = {
  readonly knowledgeBase?: {
    readonly knowledgeBase: {
      readonly __typename: "KnowledgeBaseSources";
      readonly edge: ReadonlyArray<{
        readonly node: {
          readonly sourceType: string;
        };
      } | null | undefined>;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type mainSideNavKBTypeCheckerQuery = {
  response: mainSideNavKBTypeCheckerQuery$data;
  variables: mainSideNavKBTypeCheckerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "container"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEnabled"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "container",
    "variableName": "container"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "sourceType"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainSideNavKBTypeCheckerQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "KnowledgeBaseQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeBase",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "kind": "LinkedField",
                "name": "knowledgeBase",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "KnowledgeBaseSourceEdge",
                          "kind": "LinkedField",
                          "name": "edge",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "KnowledgeBaseSource",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "RequiredField",
                                  "field": (v6/*: any*/),
                                  "action": "THROW",
                                  "path": "knowledgeBase.knowledgeBase.edge.node.sourceType"
                                }
                              ]
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "knowledgeBase.knowledgeBase.edge"
                      }
                    ],
                    "type": "KnowledgeBaseSources"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainSideNavKBTypeCheckerQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "KnowledgeBaseQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeBase",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "kind": "LinkedField",
                "name": "knowledgeBase",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "KnowledgeBaseSourceEdge",
                        "kind": "LinkedField",
                        "name": "edge",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "KnowledgeBaseSource",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "KnowledgeBaseSources"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a22d0ca655cf4288f757f976fb178eb41f2f12035fd04dc15fd5ee0d49d43033",
    "metadata": {},
    "name": "mainSideNavKBTypeCheckerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "08ff2357eb14da4040baeb3029f7c34a";

export default node;
